import { Link, useLocation } from "react-router-dom";
import media from "../../../media";
import { useSelector } from "react-redux";
import { message } from "antd";
import { sideMenu } from "../../../utils/Constants";

export default function Sidebar() {
  const location = useLocation();
  const activeMenu = location?.pathname;

  let storeRole = useSelector((state) => state.auth.role);
  const ercount = useSelector((state) => {
    return state.auth.ercount;
  });

  return (
    <div
      className="aside aside-left aside-fixed d-flex flex-column flex-row-auto custom-aside-menu-style"
      id="kt_aside"
    >
      <div className="brand flex-column-auto" id="kt_brand">
        <Link to="/dashboard" className="brand-logo">
          <img alt="Logo" src={media.newLogo.svg} className="logo-style" />
        </Link>
      </div>
      {/*Except approver who can not send expense request can use this event*/}
      <div
        className="aside-menu-wrapper flex-column-fluid scrollbars"
        id="kt_aside_menu_wrapper"
      >
        <div
          id="kt_aside_menu"
          className="aside-menu"
          data-menu-vertical="1"
          data-menu-scroll="1"
          data-menu-dropdown-timeout="500"
        >
          <ul className="menu-nav">
            {sideMenu &&
              typeof sideMenu === "object" &&
              sideMenu[storeRole].map((menuItem, index) => {
                const [key, value] = Object.entries(menuItem)[0]; // Extract key and value
                return (
                  <li
                    key={key}
                    className={
                      activeMenu === key
                        ? "menu-item menu-item-active"
                        : "menu-item"
                    }
                    onClick={() => {
                      message.destroy("publishDraftExpenseError");
                    }}
                  >
                    <Link className="menu-link" to={key}>
                      <span className="svg-icon menu-icon">
                        <img src={value.icon} alt={value.name} />
                      </span>
                      <span className="menu-text">
                        {value.name}
                        {value.showCount === "yes" && (
                          <span className="label label-dark label-lg ml-2 text-white font-weight-bold">
                            {ercount ? ercount : 0}
                          </span>
                        )}
                      </span>
                    </Link>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </div>
  );
}
